import React, { useRef, useEffect } from "react";
import {
  TextInput,
  Record,
  regex,
  minLength,
  maxLength,
  SimpleForm,
  SelectInput,
} from "react-admin";
import { required, email, useTranslate } from "react-admin";
import "../../common/styles/form-style.css";
import { useAppData } from "../../../common/hooks/useAppData";
import Inputmask from "inputmask";
import {
  MasterFleetManagerDto,
  MasterFleetManagerListDto,
} from "../../../common/data/service-proxies";
import { ProtectedElement } from "../../common/field-permissions/ProtectedElement";

interface MasterFleetManagerFormProps {
  record?: MasterFleetManagerDto & MasterFleetManagerListDto & Record;
  toolbar?: React.ReactElement;
  isEdit?: boolean;
}

export const MasterFleetManagerForm = ({
  isEdit,
  ...props
}: MasterFleetManagerFormProps) => {
  const roles =
    useAppData((x) => x.roles)?.map((x) => ({ id: x.name, name: x.name })) ??
    [];
  const phoneRef = useRef<HTMLInputElement>(null);
  const translate = useTranslate();

  useEffect(() => {
    if (!phoneRef.current) {
      return;
    }

    var im = new Inputmask("(999) 999-9999");
    im.mask(phoneRef.current);
  });

  return (
    <SimpleForm className="form-create-edit" variant="outlined" {...props}>
      <ProtectedElement source="name">
        <TextInput
          source="name"
          label="resources.admin-fleet-managers.labels.name"
          validate={[required(), minLength(2), maxLength(30)]}
          autoComplete="given-name"
        />
      </ProtectedElement>
      <ProtectedElement source="surname">
        <TextInput
          source="surname"
          label="resources.admin-fleet-managers.labels.surname"
          validate={[required(), minLength(2), maxLength(30)]}
          autoComplete="family-name"
        />
      </ProtectedElement>
      <ProtectedElement source="email">
        <TextInput
          source="email"
          label="resources.common.labels.email"
          validate={[required(), email()]}
          disabled={isEdit}
        />
      </ProtectedElement>
      <ProtectedElement source="phoneNumber">
        <TextInput
          inputRef={phoneRef}
          source="phoneNumber"
          label="resources.common.labels.phone"
          validate={[
            required(),
            regex(
              /^(\([0-9]{3}\) |[0-9]{3}-)[0-9]{3}-[0-9]{4}$/,
              translate("resources.common.labels.mustBeValidPhoneNumber")
            ),
          ]}
        />
      </ProtectedElement>
      <ProtectedElement source="roleName">
        <SelectInput
          source="roleName"
          label="resources.admin-fleet-managers.labels.role"
          choices={roles}
          validate={required()}
        />
      </ProtectedElement>
    </SimpleForm>
  );
};
